import { API_BASE_URL } from '../../constants'

const BASE = `${API_BASE_URL}/api`
const POLL_MS = 1000
const IMG_TIMEOUT_MS = 300_000
const VID_TIMEOUT_MS = 900_000

// ComfyUI nu ne dă progres real per pas fără websocket (vezi notele din cod
// pentru getQueueState), iar starea de coadă tot nu arăta convingător pe bară.
// Simplu și predictibil: o durată estimată din observații reale (poză ~15-16s,
// video ~25s), bara crește lin spre 95% pe baza ei, iar dacă treaba se termină
// mai repede sărim direct la 100% — nu rămânem blocați sub finalul real.
const IMG_EXPECTED_MS = 16_000
const VID_EXPECTED_MS = 25_000

async function toBlob(source) {
  const r = await fetch(source)
  return r.blob()
}

async function pollJob(path, jobId, onProgress, timeoutMs, expectedMs) {
  const start = Date.now()

  while (Date.now() - start < timeoutMs) {
    const r = await fetch(`${BASE}/${path}`)
    if (!r.ok) throw new Error(`Status check failed: ${r.status}`)
    const data = await r.json()

    if (data.status === 'done') return { url: data.url, jobId }
    if (data.status === 'error') throw new Error(data.message || 'Generarea a eșuat.')

    onProgress?.(Math.min((Date.now() - start) / expectedMs, 0.95))

    await new Promise((res) => setTimeout(res, POLL_MS))
  }
  throw new Error('Timeout: generarea a durat prea mult.')
}

export async function generateImage(selfieBase64, { personaId, gender, variant, fallbackPrompt }, onProgress) {
  const form = new FormData()
  form.append('selfie', await toBlob(selfieBase64), 'selfie.jpg')
  form.append('persona', personaId)
  form.append('gender', gender)
  // PHP alege promptul din fișierele scrise de mână pentru persona/gender; asta e
  // doar rezervă, pentru combinațiile care încă n-au fișiere completate (ex: female).
  if (fallbackPrompt) form.append('prompt', fallbackPrompt)
  // Cerere explicită a unei variante (ex: pagina de test /test) în loc de alegere random.
  if (variant != null) form.append('variant', variant)

  const r = await fetch(`${BASE}/photo`, { method: 'POST', body: form })
  if (!r.ok) throw new Error(`Pornirea generării a eșuat: ${r.status}`)
  const { jobId, variant: usedVariant, prompt } = await r.json()

  const result = await pollJob(`photo/${jobId}`, jobId, onProgress, IMG_TIMEOUT_MS, IMG_EXPECTED_MS)
  return { ...result, variant: usedVariant, prompt }
}

export async function listPhotoVariants(personaId, gender) {
  const r = await fetch(`${BASE}/prompts/${personaId}/${gender}`)
  if (!r.ok) throw new Error(`Listarea variantelor a eșuat: ${r.status}`)
  const { variants } = await r.json()
  return variants
}

export async function generateVideo(imageUrl, { personaId, gender, variant, fallbackPrompt }, onProgress) {
  const form = new FormData()
  form.append('image', await toBlob(imageUrl), 'photo.png')
  form.append('persona', personaId)
  form.append('gender', gender)
  // Aceeași variantă (1/2) aleasă la poză, ca filmul să rămână perechea ei vizuală.
  if (variant != null) form.append('variant', variant)
  if (fallbackPrompt) form.append('prompt', fallbackPrompt)

  const r = await fetch(`${BASE}/video`, { method: 'POST', body: form })
  if (!r.ok) throw new Error(`Pornirea generării video a eșuat: ${r.status}`)
  const { jobId } = await r.json()

  return pollJob(`video/${jobId}`, jobId, onProgress, VID_TIMEOUT_MS, VID_EXPECTED_MS)
}
